"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.dot-all.js");
require("core-js/modules/es.regexp.sticky.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.repeat.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.string.trim-end.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.string.ends-with.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.error.cause.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
function _export(target, all) {
  for (var name in all) Object.defineProperty(target, name, {
    enumerable: true,
    get: all[name]
  });
}
_export(exports, {
  normalize: function normalize() {
    return _normalize;
  },
  url: function url() {
    return _url;
  },
  number: function number() {
    return _number;
  },
  percentage: function percentage() {
    return _percentage;
  },
  length: function length() {
    return _length;
  },
  lineWidth: function lineWidth() {
    return _lineWidth;
  },
  shadow: function shadow() {
    return _shadow;
  },
  color: function color() {
    return _color2;
  },
  image: function image() {
    return _image;
  },
  gradient: function gradient() {
    return _gradient;
  },
  position: function position() {
    return _position;
  },
  familyName: function familyName() {
    return _familyName;
  },
  genericName: function genericName() {
    return _genericName;
  },
  absoluteSize: function absoluteSize() {
    return _absoluteSize;
  },
  relativeSize: function relativeSize() {
    return _relativeSize;
  }
});
var _color = require("./color");
var _parseBoxShadowValue = require("./parseBoxShadowValue");
var _splitAtTopLevelOnly = require("./splitAtTopLevelOnly");
var cssFunctions = ["min", "max", "clamp", "calc"];
// Ref: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types
function isCSSFunction(value) {
  return cssFunctions.some(function (fn) {
    return new RegExp("^".concat(fn, "\\(.*\\)")).test(value);
  });
}
// These properties accept a `<dashed-ident>` as one of the values. This means that you can use them
// as: `timeline-scope: --tl;`
//
// Without the `var(--tl)`, in these cases we don't want to normalize the value, and you should add
// the `var()` yourself.
//
// More info:
// - https://drafts.csswg.org/scroll-animations/#propdef-timeline-scope
// - https://developer.mozilla.org/en-US/docs/Web/CSS/timeline-scope#dashed-ident
//
var AUTO_VAR_INJECTION_EXCEPTIONS = new Set([
// Concrete properties
"scroll-timeline-name", "timeline-scope", "view-timeline-name", "font-palette",
// Shorthand properties
"scroll-timeline", "animation-timeline", "view-timeline"]);
function _normalize(value) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isVarException = context && AUTO_VAR_INJECTION_EXCEPTIONS.has(context.property);
  if (value.startsWith("--") && !isVarException) {
    return "var(".concat(value, ")");
  }
  // Keep raw strings if it starts with `url(`
  if (value.includes("url(")) {
    return value.split(/(url\(.*?\))/g).filter(Boolean).map(function (part) {
      if (/^url\(.*?\)$/.test(part)) {
        return part;
      }
      return _normalize(part, context, false);
    }).join("");
  }
  // Convert `_` to ` `, except for escaped underscores `\_`
  value = value.replace(/([^\\])_+/g, function (fullMatch, characterBefore) {
    return characterBefore + " ".repeat(fullMatch.length - 1);
  }).replace(/^_/g, " ").replace(/\\_/g, "_");
  // Remove leftover whitespace
  if (isRoot) {
    value = value.trim();
  }
  value = normalizeMathOperatorSpacing(value);
  return value;
}
/**
 * Add spaces around operators inside math functions
 * like calc() that do not follow an operator, '(', or `,`.
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeMathOperatorSpacing(value) {
  var preventFormattingInFunctions = ["theme"];
  var preventFormattingKeywords = ["min-content", "max-content", "fit-content",
  // Env
  "safe-area-inset-top", "safe-area-inset-right", "safe-area-inset-bottom", "safe-area-inset-left", "titlebar-area-x", "titlebar-area-y", "titlebar-area-width", "titlebar-area-height", "keyboard-inset-top", "keyboard-inset-right", "keyboard-inset-bottom", "keyboard-inset-left", "keyboard-inset-width", "keyboard-inset-height", "radial-gradient", "linear-gradient", "conic-gradient", "repeating-radial-gradient", "repeating-linear-gradient", "repeating-conic-gradient"];
  return value.replace(/(calc|min|max|clamp)\(.+\)/g, function (match) {
    var result = "";
    function lastChar() {
      var char = result.trimEnd();
      return char[char.length - 1];
    }
    var _loop = function _loop(_i) {
      function peek(word) {
        return word.split("").every(function (char, j) {
          return match[_i + j] === char;
        });
      }
      function consumeUntil(chars) {
        var minIndex = Infinity;
        var _iterator = _createForOfIteratorHelper(chars),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _char = _step.value;
            var index = match.indexOf(_char, _i);
            if (index !== -1 && index < minIndex) {
              minIndex = index;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var result = match.slice(_i, minIndex);
        _i += result.length - 1;
        return result;
      }
      var char = match[_i];
      // Handle `var(--variable)`
      if (peek("var")) {
        // When we consume until `)`, then we are dealing with this scenario:
        //   `var(--example)`
        //
        // When we consume until `,`, then we are dealing with this scenario:
        //   `var(--example, 1rem)`
        //
        //   In this case we do want to "format", the default value as well
        result += consumeUntil([")", ","]);
      } else if (preventFormattingKeywords.some(function (keyword) {
        return peek(keyword);
      })) {
        var keyword = preventFormattingKeywords.find(function (keyword) {
          return peek(keyword);
        });
        result += keyword;
        _i += keyword.length - 1;
      } else if (preventFormattingInFunctions.some(function (fn) {
        return peek(fn);
      })) {
        result += consumeUntil([")"]);
      } else if (peek("[")) {
        result += consumeUntil(["]"]);
      } else if (["+", "-", "*", "/"].includes(char) && !["(", "+", "-", "*", "/", ","].includes(lastChar())) {
        result += " ".concat(char, " ");
      } else {
        result += char;
      }
      i = _i;
    };
    for (var i = 0; i < match.length; i++) {
      _loop(i);
    }
    // Simplify multiple spaces
    return result.replace(/\s+/g, " ");
  });
}
function _url(value) {
  return value.startsWith("url(");
}
function _number(value) {
  return !isNaN(Number(value)) || isCSSFunction(value);
}
function _percentage(value) {
  return value.endsWith("%") && _number(value.slice(0, -1)) || isCSSFunction(value);
}
// Please refer to MDN when updating this list:
// https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Values_and_units
// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Container_Queries#container_query_length_units
var lengthUnits = ["cm", "mm", "Q", "in", "pc", "pt", "px", "em", "ex", "ch", "rem", "lh", "rlh", "vw", "vh", "vmin", "vmax", "vb", "vi", "svw", "svh", "lvw", "lvh", "dvw", "dvh", "cqw", "cqh", "cqi", "cqb", "cqmin", "cqmax"];
var lengthUnitsPattern = "(?:".concat(lengthUnits.join("|"), ")");
function _length(value) {
  return value === "0" || new RegExp("^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?".concat(lengthUnitsPattern, "$")).test(value) || isCSSFunction(value);
}
var lineWidths = new Set(["thin", "medium", "thick"]);
function _lineWidth(value) {
  return lineWidths.has(value);
}
function _shadow(value) {
  var parsedShadows = (0, _parseBoxShadowValue.parseBoxShadowValue)(_normalize(value));
  var _iterator2 = _createForOfIteratorHelper(parsedShadows),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var parsedShadow = _step2.value;
      if (!parsedShadow.valid) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return true;
}
function _color2(value) {
  var colors = 0;
  var result = (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(value, "_").every(function (part) {
    part = _normalize(part);
    if (part.startsWith("var(")) return true;
    if ((0, _color.parseColor)(part, {
      loose: true
    }) !== null) return colors++, true;
    return false;
  });
  if (!result) return false;
  return colors > 0;
}
function _image(value) {
  var images = 0;
  var result = (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(value, ",").every(function (part) {
    part = _normalize(part);
    if (part.startsWith("var(")) return true;
    if (_url(part) || _gradient(part) || ["element(", "image(", "cross-fade(", "image-set("].some(function (fn) {
      return part.startsWith(fn);
    })) {
      images++;
      return true;
    }
    return false;
  });
  if (!result) return false;
  return images > 0;
}
var gradientTypes = new Set(["conic-gradient", "linear-gradient", "radial-gradient", "repeating-conic-gradient", "repeating-linear-gradient", "repeating-radial-gradient"]);
function _gradient(value) {
  value = _normalize(value);
  var _iterator3 = _createForOfIteratorHelper(gradientTypes),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var type = _step3.value;
      if (value.startsWith("".concat(type, "("))) {
        return true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
}
var validPositions = new Set(["center", "top", "right", "bottom", "left"]);
function _position(value) {
  var positions = 0;
  var result = (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(value, "_").every(function (part) {
    part = _normalize(part);
    if (part.startsWith("var(")) return true;
    if (validPositions.has(part) || _length(part) || _percentage(part)) {
      positions++;
      return true;
    }
    return false;
  });
  if (!result) return false;
  return positions > 0;
}
function _familyName(value) {
  var fonts = 0;
  var result = (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(value, ",").every(function (part) {
    part = _normalize(part);
    if (part.startsWith("var(")) return true;
    // If it contains spaces, then it should be quoted
    if (part.includes(" ")) {
      if (!/(['"])([^"']+)\1/g.test(part)) {
        return false;
      }
    }
    // If it starts with a number, it's invalid
    if (/^\d/g.test(part)) {
      return false;
    }
    fonts++;
    return true;
  });
  if (!result) return false;
  return fonts > 0;
}
var genericNames = new Set(["serif", "sans-serif", "monospace", "cursive", "fantasy", "system-ui", "ui-serif", "ui-sans-serif", "ui-monospace", "ui-rounded", "math", "emoji", "fangsong"]);
function _genericName(value) {
  return genericNames.has(value);
}
var absoluteSizes = new Set(["xx-small", "x-small", "small", "medium", "large", "x-large", "x-large", "xxx-large"]);
function _absoluteSize(value) {
  return absoluteSizes.has(value);
}
var relativeSizes = new Set(["larger", "smaller"]);
function _relativeSize(value) {
  return relativeSizes.has(value);
}